import "./scroll-to-top.scss";
import * as scrollToTop from "./scroll-to-top-util";

export default function ScrollToTop() {
  const prose = document.querySelector(".prose");
  scrollToTop.default("main", prose, false);
}
ScrollToTop();
